var L={SMALL:"SMALL",MEDIUM:"MEDIUM",LARGE:"LARGE",XLARGE:"XLARGE"};export{L as Size};
